import axiosClient from "../axiosInstance";

const getDistricts = async () => {
  return axiosClient.get("/bsa/districts").then((response) => {
    return response.data;
  });
};

const bsaDataService = {
  getDistricts,
};

export default bsaDataService;
